import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

/**
 * Admin home. Phase 8b–8d fill the panels in; this stub gives the
 * shell something to land on so the auth + MFA + sidebar wiring is
 * verifiable end-to-end before we wire data.
 */
export function DashboardPage() {
  return (
    <div className="space-y-6">
      <header>
        <h1 className="text-3xl font-black tracking-tight">Dashboard overview</h1>
        <p className="mt-1 text-sm text-muted-foreground">
          Monitor subscriptions, assignments, GDPR and partner activity.
        </p>
      </header>

      <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-4">
        <KpiCard title="Users" hint="Total registered candidates + agents" />
        <KpiCard title="Premium revenue" hint="Last 30 days" />
        <KpiCard title="Agent assignments" hint="In-flight + delivered" />
        <KpiCard title="GDPR requests" hint="Awaiting action" />
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Coming soon</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-muted-foreground">
            Dashboard widgets land with Phase 8b–8d. Use the sidebar to navigate the management
            surfaces — each one is wired against the existing Phase 5/6 backend.
          </p>
        </CardContent>
      </Card>
    </div>
  );
}

function KpiCard({ title, hint }: { title: string; hint: string }) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-base">{title}</CardTitle>
      </CardHeader>
      <CardContent>
        <p className="text-3xl font-black">—</p>
        <p className="mt-1 text-xs text-muted-foreground">{hint}</p>
      </CardContent>
    </Card>
  );
}
